export const fetchClientData = async (props: any) => {
  const data = await props.record.ref.parent.parent.get();
  return data.data();
};
